<template>
  <div>
    <b-card title="Instâncias SigaWeb">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-siga-instance-register' }"
      >
        <feather-icon icon="PlusIcon" />
        Adicionar
      </b-button>
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="true"
        :hasSyncButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import sigaInstanceService from "@/providers/sigaInstanceService";
import AppConstants from "@/appConstants";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BButton,
    BCard,
    CustomGTable,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "name", label: "Nome", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por nome', trigger: 'enter' } },
        { field: "url", label: "URL", sortable: false },
        { field: "priority", label: "Prioridade", sortable: true },
        { field: "active", label: "Ativo", type: "boolean", sortable: true },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true },
      ],
    };
  },
  mounted() {
    this.loadData();
    if (this.urlQuery) {
      this.page = this.urlQuery.page ? parseInt(this.urlQuery.page) : 1;
      this.limit = this.urlQuery.limit ? parseInt(this.urlQuery.limit) : AppConstants.PAGINATOR_DEFAULT_LIMIT;
    }
  },
  methods: {
    loadData() {
      this.tableLoading = true;
      const params = buildParamsRouteQuery({
        page: this.page,
        limit: this.limit,
        name: this.filter.name,
      });

      onlyLatestRequest(this, 'loadData', sigaInstanceService.getAllSigaInstance(params))
        .then(response => {
          this.data = response.data;
          this.totalRows = response.totalRows;
          this.displayTable = true;
        })
        .catch(error => {
          this.displayTable = true;
          messagesNotifyHelper.showMessageNotifyError(this, error);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    onChangePage(page) {
      this.page = page;
      setRouteQuery(this.$router, { page: this.page, limit: this.limit });
      this.loadData();
    },
    onEdit(row) {
      this.$router.push({ name: 'admin-siga-instance-register-update', params: { id: row._id } });
    },
    onDelete(row) {
      messageDialogHelper.showDeleteMessageDialog(this, () => {
        sigaInstanceService.deleteSigaInstance(row._id)
          .then(() => {
            messagesNotifyHelper.showMessageNotifySuccess(this, 'Instância deletada com sucesso');
            this.loadData();
          })
          .catch(error => {
            messagesNotifyHelper.showMessageNotifyError(this, error);
          });
      });
    },
    onSortChange(sortField) {
      this.sortField = sortField;
      this.loadData();
    },
    onFilter(filter) {
      this.filter = filter;
      this.page = 1;
      setRouteQuery(this.$router, { page: this.page, limit: this.limit });
      this.loadData();
    },
  },
};
</script>
